






















import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'

export default {
    name: 'abs_table'

    props:
        date:
            required: true

    watch:
        date: (new_one, old_one)->
            if new_one != old_one
                @get_vpe_absence_set()

    data: ()->
        loading: true
        search: ''
        abs_datas: []
        counted_users: []
        abs_table_key: ''
        day_part_options: @$store.state.day_part_options

    computed:
        data_filtered: ()->
            self = @
            data = @abs_datas.filter (x) ->
                start_date = self.date_formatter(x.start)
                end_date = self.date_formatter(x.end)

                !self.search || x.user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user_str.toLowerCase().includes(self.search.toLowerCase())\
                || start_date.includes(self.search.toLowerCase()) \
                || end_date.includes(self.search.toLowerCase()) \
                || x.absence_type.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.absence_type.label.toLowerCase().includes(self.search.toLowerCase())\
                || x.absence_type.group.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.absence_type.group.toLowerCase().includes(self.search.toLowerCase())\
                || x.value.includes(self.search.toLowerCase())
            @users_counting(data)
            @abs_table_key = +new Date()
            return data

    methods:
        date_formatter: t.date_formatter

        span_method: ({ row, column, rowIndex, columnIndex })->
            if columnIndex == 0
                if rowIndex == 0
                    return [@counted_users[row.user_str], 1]
                else
                    if row.user_str != @data_filtered[rowIndex - 1]['user_str']
                        return [@counted_users[row.user_str], 1]
                    else
                        return [0, 0]
            return

        users_counting: (datas)->
            @counted_users = datas
                .map (x)->
                    return x.user_str
                .reduce (acc, user_str)->
                    if user_str in Object.keys(acc)
                        acc[user_str] += 1
                    else
                        acc[user_str] = 1
                    return acc
                , {}
            # console.log "USERS_COUNTING", @counted_users
            return

        get_vpe_absence_set: ()->
            self = @
            # console.log "GET ABS", @date
            q.run('get_vpe_absence_set', [@$store.getters.current_company.uid, @date])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("abs_table: get_vpe_absence_set: then", e.message)
                else
                    # console.log "GET_VPE_ABSENCE_SET : ", resp.body.data.vpe_absence_set
                    if resp.body.data.vpe_absence_set != null
                        self.abs_datas = resp.body.data.vpe_absence_set
                        self.loading = false
            .catch (resp)->
                n.catch_error(resp, "abs_table: get_vpe_absence_set()")
            
    beforeMount: ()->
        # console.log "beforeMount abs_table", @date
        @get_vpe_absence_set()
}
